import {
  GET_BRANCHES_REQUEST,
  GET_BRANCHES_SUCCESS,
  GET_BRANCHES_ERROR,
  GET_AUDIT_BRANCHES_REQUEST,
  GET_AUDIT_BRANCHES_SUCCESS,
  GET_AUDIT_BRANCHES_ERROR,
  CREATE_CATEGORYBRANCH_REQUEST,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_ERROR,
  UPDATE_BRANCH_REQUEST,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_ERROR,
} from './branchActionTypes';

const initialState = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  message: '',
  branches: [],
  auditBranches: [],
  pagination: {},
};

export default function branchReducer(state = initialState, action) {
  const { type, payload, isLoading, isSuccess, message } = action;

  switch (type) {
    case GET_BRANCHES_REQUEST:
      return {
        isLoading,
      };
    case GET_BRANCHES_SUCCESS:
      return {
        isLoading,
        branches: payload.data,
        pagination: payload,
      };
    case GET_BRANCHES_ERROR:
      return {
        isLoading,
        message,
      };
    case GET_AUDIT_BRANCHES_REQUEST:
      return {
        isLoading,
      };
    case GET_AUDIT_BRANCHES_SUCCESS:
      return {
        isLoading,
        auditBranches: payload.data,
      };
    case GET_AUDIT_BRANCHES_ERROR:
      return {
        isLoading,
        message,
      };
    case CREATE_CATEGORYBRANCH_REQUEST:
      return {
        ...state,
        isLoading,
        isSuccess,
      };
    case CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        isLoading,
        isSuccess,
      };
    case CREATE_BRANCH_ERROR:
      return {
        ...state,
        isLoading,
        isSuccess,
        message,
      };
    case UPDATE_BRANCH_REQUEST:
      return {
        ...state,
        isLoading,
        isSuccess,
      };
    case UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
        isLoading,
        isSuccess,
      };
    case UPDATE_BRANCH_ERROR:
      return {
        ...state,
        isLoading,
        isSuccess,
        message,
      };
    default: {
      return state;
    }
  }
}
